import Localization from 'lib/localization';

export default {
    lxBlockTitle() {
        return Localization.get('badoo_safety_center@navigation.updates.title');
    },

    lxBlockText() {
        return Localization.get('badoo_safety_center@updates.text');
    },
};
